<template lang="pug">
    div
        .title Monto:
        v-text-field.title#bank-transfer-pay-input(
            ref="amountInput"
            :mask="mixCurrencyMask(transferPayment, 12)"
            placeholder="Ingrese monto pagado por transferencia bancaria"
            prefix="$"
            v-model="transferPayment"
            :rules='[rules.required, rules.validPayment, rules.notZero]'
            @input="setTransferPayment()"
            @keyup.enter="handleEnter()"
            )
        v-divider
        .title N° Transferencia
        v-text-field.title#transfer-num-input(solo
            ref="voucherInput"
            mask="############"
            placeholder="Ingrese n° de Transferencia"
            v-model="transNumber"
            @keyup.enter="handleEnter()"
            )
</template>

<script>
// Mixins:
import PaymentRules from '@/mixins/PaymentRules'
import CurrencyUtils from '@/mixins/CurrencyUtils'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'bank-transfer-payment',
    props: {},
    data: function() {
        return {
            transNumber: '0',
            transferPayment: '',
        }
    },
    computed: {
        ...mapState('CashDeskModule', {
            paymentMethod: 'paymentMethod',
            total: state => state.total,
        }),

        ...mapGetters('CashDeskModule', {
            totalToPay: 'totalToPay',
        }),

        allTransbankDataSet: function() {
            return (
                // this.transNumber.length === 12 &&
                // this.transferPayment != '' &&
                parseInt(this.transferPayment) <= this.totalToPay
            )
        },
    },
    methods: {
        ...mapActions('CashDeskModule', {
            setPayment: 'setPayment',
            setPaymentDetail: 'setPaymentDetail',
        }),
        setTransferPayment() {
            if (parseInt(this.transferPayment) === 0) {
                this.setPayment('')
            } else {
                this.setPayment(this.transferPayment)
            }
        },
        handleEnter() {
            if (!this.transferPayment) {
                this.$nextTick(() => this.$refs.amountInput.focus())
                return
            } else if (!this.transNumber) {
                this.$nextTick(() => this.$refs.voucherInput.focus())
                return
            } else if (this.transferPayment && this.transNumber) {
                this.$emit('confirm')
            }
        },
    },
    watch: {
        /**
         * @description updates payment details in store depending of they are fully set in form or not.
         */
        allTransbankDataSet: function(newVal, oldVal) {
            if (newVal) {
                this.setPayment(this.transferPayment)
                let payload = {
                    transNumber: this.transNumber || 0,
                }
                this.setPaymentDetail(payload)
            } else {
                this.setPayment('')
                this.setPaymentDetail(null)
            }
        },
    },
    components: {},
    mixins: [PaymentRules, CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function() {
        this.TransNumber = ''
        //this.transferPayment = this.totalToPay.toString()
        this.$nextTick(() => this.$refs.amountInput.focus())
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
